<template>
  <div>
    <!-- Botão Adicionar Terceiros -->
    <div class="my-5">
      <vs-button
        type="border"
        class="buttonStyle"
        icon="add"
        icon-after
        @click="adicionaTerceiro"
        v-if="!modeAnalise"
        >Adicionar Terceiro</vs-button
      >
    </div>

    <div slot="header"><h3 class="my-5">Terceiros</h3></div>

    <!-- Lista Terceiros em Desktop-->
    <div v-if="terceiros.length > 0" class="showDesktop">
      <table class="w-full">
        <thead>
          <th>Protocolo</th>
          <th>Situação</th>
          <th>Nome</th>
          <th>Telefone</th>
          <th>Placa</th>
          <th>Marca</th>
          <th>Modelo</th>
          <th>Data Cadastro</th>
          <th class="text-center">Ação</th>
        </thead>
        <tbody>
          <tr v-for="terceiro in terceiros" :key="terceiro.idEnvolvido">
            <td>{{ terceiro.protocolo }}</td>
            <td>
              <vs-chip :color="terceiro.corStatus">{{
                terceiro.nomeStatus ? terceiro.nomeStatus : 'Sem status'
              }}</vs-chip>
            </td>
            <td>{{ terceiro.nome }}</td>
            <td>{{ terceiro.telefone }}</td>
            <td>{{ terceiro.placa }}</td>
            <td>{{ terceiro.veiculoMarca }}</td>
            <td>{{ terceiro.veiculoModelo }}</td>
            <td>{{ terceiro.dataCriacaoEvento }}</td>
            <td class="text-center flex gap-3 justify-center">
              <vs-button
                radius
                color="warning"
                size="small"
                class="text-lg"
                icon="edit"
                @click="redirecionaTelaEdit(terceiro.idEnvolvido)"
              />
              <vs-button
                radius
                color="danger"
                size="small"
                class="text-lg"
                icon="delete"
                v-if="!modeAnalise"
                @click="openModalDelete(terceiro)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Lista Terceiros em mobile -->
    <vs-collapse v-if="terceiros.length > 0" class="showMobile">
      <vs-collapse-item
        v-for="terceiro in terceiros"
        :key="terceiro.idEnvolvido"
      >
        <div slot="header">
          <p><b>Protocolo:</b> {{ terceiro.protocolo }}</p>

          <p><b>Situação:</b> {{ terceiro.nomeStatus }}</p>
          <p><b>Nome:</b> {{ terceiro.nome }}</p>
        </div>
        <div>
          <p><b>Telefone:</b></p>
          {{ terceiro.telefone }}
          <p>
            <b>Placa:</b>
          </p>
          {{ terceiro.placa }}
          <p><b>Marca:</b></p>
          {{ terceiro.veiculoMarca }}
          <p><b>Modelo:</b></p>
          {{ terceiro.veiculoModelo }}

          {{ terceiro.dataCriacaoEvento }}
          <p class="flex justify-center mt-3 gap-3">
            <vs-button
              @click="redirecionaTelaEdit(terceiro.idEnvolvido)"
              color="warning"
              size="small"
              class="text-lg w-full"
              >Editar</vs-button
            >
            <vs-button
              color="danger"
              size="small"
              class="text-lg w-full"
              v-if="!modeAnalise"
              @click="openModalDelete(terceiro)"
              >Deletar</vs-button
            >
          </p>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <!-- Modal Deletar Terceiro -->
    <vs-popup :active.sync="modalDeleteAtivo" :title="'Confirmar'">
      <div>
        <div>
          <h5>Certeza de que deseja apagar os dados do terceiro?</h5>
          <div v-if="terceiroSelecionado" class="m-5">
            <p>
              <b>Nome:</b>
              {{
                terceiroSelecionado.nome
                  ? terceiroSelecionado.nome
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Telefone:</b>
              {{
                terceiroSelecionado.telefone
                  ? terceiroSelecionado.telefone
                  : 'não consta'
              }}
              -
              {{
                terceiroSelecionado.celular ? terceiro.celular : 'não consta'
              }}
            </p>
            <p>
              <b>Protocolo:</b>
              {{
                terceiroSelecionado.protocolo
                  ? terceiroSelecionado.protocolo
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Placa:</b>
              {{
                terceiroSelecionado.placa
                  ? terceiroSelecionado.placa
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Marca:</b>
              {{
                terceiroSelecionado.veiculoMarca
                  ? terceiroSelecionado.veiculoMarca
                  : 'não consta'
              }}
            </p>
            <p>
              <b>Modelo:</b>
              {{
                terceiroSelecionado.modelo
                  ? terceiroSelecionado.veiculoModelo
                  : 'não consta'
              }}
            </p>
          </div>
          <vs-alert
            v-if="terceiroSelecionado"
            title="Atenção"
            active="true"
            color="danger"
            class="mb-2"
          >
            <p>
              Ao apagar os dados do terceiro, você irá perder todas as
              informações, além de fotos e documentos que estão anexados ao
              terceiro.
            </p>
            <p>Essa ação não pode ser revertida.</p>
          </vs-alert>
        </div>
        <div class="flex justify-end gap-3">
          <vs-button
            color="primary"
            class="text-lg"
            @click="modalDeleteAtivo = false"
            >Cancelar</vs-button
          >

          <vs-button
            color="danger"
            class="text-lg"
            @click="deletaTerceiro(terceiroSelecionado.idEnvolvido)"
            >Deletar</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import eventoService from './../service';
import notify from './../../../../../utils/notify';
import utils from '../../../../../utils/functions';
import { TIPO_ENVOLVIDO } from '../const';
export default {
  props: ['idEvento', 'terceiros', 'modeAnalise'],
  data() {
    return {
      modalDeleteAtivo: false,
      terceiroSelecionado: null,
    };
  },
  components: {},
  methods: {
    redirecionaTelaEdit(idEnvolvido) {
      const route = `/editar-eventos-terceiro/${this.idEvento}/${idEnvolvido}`;
      this.$router.push(route);
    },
    async adicionaTerceiro() {
      try {
        this.$vs.loading();
        const { idUsuario } = utils.getDecoded(localStorage);
        const result = await eventoService.postTerceiro(
          this.idEvento,
          TIPO_ENVOLVIDO.TERCEIRO,
          idUsuario,
        );
        this.redirecionaTelaEdit(result.idEnvolvido);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async deletaTerceiro(idEnvolvido) {
      try {
        this.$vs.loading();
        await eventoService.softDeleteTerceiro(idEnvolvido);

        // eslint-disable-next-line vue/no-mutating-props
        this.terceiros = this.terceiros.filter(
          (x) => x.idEnvolvido !== idEnvolvido,
        );

        this.modalDeleteAtivo = false;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    openModalDelete(terceiro) {
      this.modalDeleteAtivo = true;
      this.terceiroSelecionado = terceiro;
    },
  },
};
</script>

<style scoped>
.buttonStyle {
  font-weight: 500;
  display: flex;
  justify-content: space-around;
}

.buttonStyle > span {
  display: flex;
  justify-content: space-around;
}
.showDesktop {
  display: block;
}

.showMobile {
  display: none;
}

@media (max-width: 500px) {
  .showDesktop {
    display: none;
  }

  .showMobile {
    display: block;
  }
}
</style>
